var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-info"},[_vm._v(" "+_vm._s(_vm.$t('global.cheval_introuvable'))+". "),_c('router-link',{attrs:{"to":{ name: 'horseListe' }}},[_vm._v(_vm._s(_vm.$t('global.retourner_sur_liste')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }